import { render, staticRenderFns } from "./NotificationTimeLimit.vue?vue&type=template&id=1a980ef2"
import script from "./NotificationTimeLimit.vue?vue&type=script&lang=ts"
export * from "./NotificationTimeLimit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports